import { render, staticRenderFns } from "./myGrabbing.vue?vue&type=template&id=6c928272&scoped=true&"
import script from "./myGrabbing.vue?vue&type=script&lang=js&"
export * from "./myGrabbing.vue?vue&type=script&lang=js&"
import style0 from "./myGrabbing.vue?vue&type=style&index=0&id=6c928272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c928272",
  null
  
)

export default component.exports